import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HttpCommonService} from '../../../../../shared/services/http-common.service';
import {Observable} from 'rxjs';
import {GenericHttpResponse} from '../../../../../shared/services/interfaces/generic-http-response.interface';
import {Establecimiento} from '../clientes/clientes.interface';
import {
  EstablecimientoPayload,
  EstablecimientoResponse,
  EstablecimientoStorePayload,
  EstablecimientoAltaPayload,
  EstablecimientoPaginatedResponse
} from './establecimientos.interface';

export interface EstablecimientoFilters {
  cli_cliente_id: number;
  page?: number;
  per_page?: number;
  search?: string;
  objetivo?: string;
}

@Injectable({
  providedIn: 'root'
})
export class EstablecimientosService {
  private http = inject(HttpClient);
  private httpCommonService = inject(HttpCommonService);

  index(filters: EstablecimientoFilters): Observable<GenericHttpResponse<EstablecimientoPaginatedResponse>> {
    const url = this.httpCommonService.makeUrl('/clie/establecimientos', filters);
    return this.http.get<GenericHttpResponse<EstablecimientoPaginatedResponse>>(url);
  }

  show(id: number): Observable<GenericHttpResponse<Establecimiento>> {
    const url = this.httpCommonService.makeUrl(`/clie/establecimientos/${id}`);
    return this.http.get<GenericHttpResponse<Establecimiento>>(url);
  }

  store(body: EstablecimientoStorePayload | EstablecimientoAltaPayload): Observable<GenericHttpResponse<EstablecimientoResponse>> {
    const url = this.httpCommonService.makeUrl('/clie/establecimientos');
    return this.http.post<GenericHttpResponse<EstablecimientoResponse>>(url, body);
  }

  update(id: number, body: EstablecimientoPayload): Observable<GenericHttpResponse<EstablecimientoResponse>> {
    const url = this.httpCommonService.makeUrl(`/clie/establecimientos/${id}`);
    return this.http.put<GenericHttpResponse<EstablecimientoResponse>>(url, body);
  }

  destroy(id: number): Observable<GenericHttpResponse<EstablecimientoResponse>> {
    const url = this.httpCommonService.makeUrl(`/clie/establecimientos/${id}`);
    return this.http.delete<GenericHttpResponse<EstablecimientoResponse>>(url);
  }
}
